// extracted by mini-css-extract-plugin
export default {"Drawer":"Rf4kLUKRHynG3L8XrlSb","DrawerHead":"A7xKx8rvEGeftQSSGoKb","Active":"yeiilcjnlUzEVOv80vks","DrawerIcon":"SCVlKaeQVxae2OtYRMQw","DrawerContent":"yuQcIGH6bpD5bgOXEUV1","DrawerList":"gQ3VfnPCe1QAyaU8Rl5J","DrawerItem":"hti3_ZZkggNFfK_Oxfag","csicon":"c212Nuy9IqLqJgSLHAgy","fadeIn":"YVwkr0tP8kpGKj1arR6H"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Drawer\":\"Rf4kLUKRHynG3L8XrlSb\",\"DrawerHead\":\"A7xKx8rvEGeftQSSGoKb\",\"Active\":\"yeiilcjnlUzEVOv80vks\",\"DrawerIcon\":\"SCVlKaeQVxae2OtYRMQw\",\"DrawerContent\":\"yuQcIGH6bpD5bgOXEUV1\",\"DrawerList\":\"gQ3VfnPCe1QAyaU8Rl5J\",\"DrawerItem\":\"hti3_ZZkggNFfK_Oxfag\",\"csicon\":\"c212Nuy9IqLqJgSLHAgy\",\"fadeIn\":\"YVwkr0tP8kpGKj1arR6H\"}";
        // 1766411927474
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  